export default __webpack_public_path__ + "static/media/report.f11bc58d.svg";